import { render, staticRenderFns } from "./MyBlogs.vue?vue&type=template&id=2e9866c8&"
import script from "./MyBlogs.vue?vue&type=script&lang=js&"
export * from "./MyBlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports